<template>
  <div v-click-outside="outsideCancelAction" class="allScreen">
    <v-form fast-fail @submit.prevent="saveData" class="edit-partner">
      <div class="left-side">
        <v-file-input
          class="logo-input"
          accept="image/png, image/jpeg, image/bmp, image/svg"
          prepend-icon="mdi-camera"
          :label="$t('editPartnerPopperComponent.labels.logo')"
          variant="outlined"
          v-model="logo"
          ref="logoFileInput"
          @input="onSelectFileLogo($event)"
        ></v-file-input>
        <v-file-input
          class="cover-image-input"
          accept="image/png, image/jpeg, image/bmp, image/svg"
          prepend-icon="mdi-camera"
          :label="$t('editPartnerPopperComponent.labels.coverImage')"
          variant="outlined"
          v-model="cover_image"
          ref="coverImageFileInput"
          @input="onSelectFileCoverImage($event)"
        ></v-file-input>
        <v-text-field
          variant="outlined"
          v-model="userData.par_id"
          :label="$t('editPartnerPopperComponent.labels.id')"
          readonly
        ></v-text-field>
        <v-text-field
          variant="outlined"
          v-model="userData.par_name"
          :label="$t('editPartnerPopperComponent.labels.name')"
        ></v-text-field>
        <v-text-field
          variant="outlined"
          v-model="userData.par_company_name"
          :label="$t('editPartnerPopperComponent.labels.companyName')"
        ></v-text-field>
        <v-text-field
          variant="outlined"
          v-model="userData.par_address"
          :label="$t('editPartnerPopperComponent.labels.address')"
        ></v-text-field>
      </div>
      <div class="right-side">
        <v-text-field
          variant="outlined"
          class="vat-input"
          v-model="userData.par_tax_number"
          :label="$t('editPartnerPopperComponent.labels.vatNumber')"
        ></v-text-field>
        <v-select
          variant="outlined"
          :label="$t('editPartnerPopperComponent.labels.active')"
          :items="active"
          item-title="value"
          item-value="key"
          v-model="userData.par_active"
        ></v-select>
        <v-text-field
          variant="outlined"
          v-model="userData.par_description"
          :label="$t('editPartnerPopperComponent.labels.description')"
        ></v-text-field>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-if="userData.par_gps"
              variant="outlined"
              v-model="userData.par_gps.coordinates[0]"
              :label="$t('editPartnerPopperComponent.labels.gpsLat')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-if="userData.par_gps"
              variant="outlined"
              v-model="userData.par_gps.coordinates[1]"
              :label="$t('editPartnerPopperComponent.labels.gpsLong')"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-text-field
          variant="outlined"
          v-model="userData.par_soldable_products_number"
          :label="$t('editPartnerPopperComponent.labels.productNumber')"
        ></v-text-field> -->
      </div>
    </v-form>
    <div class="btn-row">
      <v-btn @click="cancelAction">
        {{ $t("profile.cancel") }}
      </v-btn>
      <v-btn v-if="!isCreate" @click="userDelete" color="red">
        {{ $t("profile.delete") }}
      </v-btn>
      <v-btn color="primary" @click="saveData">
        {{ $t("profile.save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { activeEnums } from "@/components/enums";

export default {
  name: "EditUserModal",
  props: {
    user: {
      type: Object,
      required: false,
    },
    isCreate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userData: {},
      logo: null,
      cover_image: null,
      active: [],
    };
  },
  mounted() {
    this.setEnums();

    Object.keys(this.user).forEach((key) => {
      this.userData[key] = this.user[key];
    });

    if (!this.userData.par_gps) {
      this.userData.par_gps = { coordinates: ["", ""] };
    }

    if (this.user.logo_base64) {
      const iconLogo = document.querySelector(".logo-input .mdi-camera");
      const logo = document.createElement("img");
      const logoSrc = document.querySelector(".logo-input  .v-input__prepend");

      iconLogo.remove();
      logo.src = this.user.logo_base64;
      logo.classList.add("prepend-img", "v-icon--clickable");
      logo.setAttribute("role", "button");
      logo.addEventListener("click", this.chooseLogo);
      logoSrc.appendChild(logo);
    }

    if (this.user.cover_image_base64) {
      const iconCoverImage = document.querySelector(
        ".cover-image-input .mdi-camera"
      );
      const coverImage = document.createElement("img");
      const coverImageSrc = document.querySelector(
        ".cover-image-input .v-input__prepend"
      );

      iconCoverImage.remove();
      coverImage.src = this.user.cover_image_base64;
      coverImage.classList.add("prepend-img", "v-icon--clickable");
      coverImage.setAttribute("role", "button");
      coverImage.addEventListener("click", this.chooseCoverImage);
      coverImageSrc.appendChild(coverImage);
    }
  },
  methods: {
    setEnums() {
      activeEnums.map((active) => {
        const activity = {
          key: active.key,
          value: this.$t(`enums.activity.${active.value}`),
        };
        this.active.push(activity);
      });
    },
    chooseLogo() {
      this.$refs.logoFileInput.click();
    },
    chooseCoverImage() {
      this.$refs.coverImageFileInput.click();
    },
    onSelectFileLogo() {
      const input = this.$refs.logoFileInput;
      const files = input.files;
      const reader = new FileReader();
      const img = document.createElement("img");
      const src = document.querySelector(".logo-input .v-input__prepend");
      if (files && files[0]) {
        reader.onload = (e) => {
          src.innerHTML = "";
          img.src = e.target.result;
          img.classList.add("prepend-img", "v-icon--clickable");
          img.setAttribute("role", "button");
          img.addEventListener("click", this.chooseLogo);
          src.appendChild(img);
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onSelectFileCoverImage() {
      const input = this.$refs.coverImageFileInput;
      const files = input.files;
      const reader = new FileReader();
      const img = document.createElement("img");
      const src = document.querySelector(
        ".cover-image-input .v-input__prepend"
      );
      if (files && files[0]) {
        reader.onload = (e) => {
          src.innerHTML = "";
          img.src = e.target.result;
          img.classList.add("prepend-img", "v-icon--clickable");
          img.setAttribute("role", "button");
          img.addEventListener("click", this.chooseCoverImage);
          src.appendChild(img);
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closePopper");
      }
    },
    outsideCancelAction(event) {
      const clickedElement = event.target;
      const classList = clickedElement.classList;

      if (classList.contains("v-overlay__scrim")) {
        this.cancelAction();
      }
    },
    saveData() {
      const bodyFormData = new FormData();
      const userData = this.userData;

      userData.par_gps.coordinates.forEach((obj) => {
        bodyFormData.append("par_gps[]", obj ? obj : null);
      });

      Object.keys(userData).forEach((key) => {
        if (
          userData[key] !== null &&
          userData[key] !== undefined &&
          key !== "par_gps" &&
          key !== "logo_base64" &&
          key !== "cover_image_base64"
        ) {
          bodyFormData.append(key, userData[key]);
        }
      });
      if (this.logo) bodyFormData.append("logo", this.logo[0]);
      if (this.cover_image)
        bodyFormData.append("cover_image", this.cover_image[0]);

      this.$emit("saveUser", bodyFormData);
      this.emitter.emit("closePopper");
    },
    userDelete() {
      const payload = {
        title: this.$t("partners.table.deleteModal.title"),
        subTitle: this.$t("partners.table.deleteModal.subTitle"),
        userId: this.user.id,
      };
      this.emitter.emit("showConfirmModal", payload);
    },
  },
  computed: {
    activeEnums() {
      return activeEnums;
    },
  },
  watch: {
    logo() {
      console.log(this.logo);
    },
    cover_image() {
      console.log(this.cover_image);
    },
  },
};
</script>

<style lang="scss" scoped>
.allScreen {
  height: 100%;
}
.logo {
  max-width: 150px;
  height: auto;
}
::v-deep(.v-input__prepend img) {
  max-width: 50px;
  height: auto;
}

.logo-input {
  ::v-deep(.v-field__input) {
    display: block;
  }
}
.edit-partner {
  display: flex;
  padding: 8px 32px;
  .left-side {
    width: 50%;
    padding: 32px;
    .v-text-field {
      margin-top: 12px;
    }
  }
  .right-side {
    width: 50%;
    padding: 32px;
    .vat-input {
      margin-top: 0px !important;
    }
    .v-text-field {
      margin-top: 12px;
    }
    .v-select {
      margin-top: 12px;
    }
  }
}
.btn-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .v-btn {
    width: 220px;
  }
}

@media (max-width: 750px) {
  .btn-row {
    .v-btn {
      width: 160px;
    }
  }
}

@media (max-width: 680px) {
  .edit-partner {
    flex-direction: column;
    padding: 8px 12px;
    .left-side {
      width: 100%;
      padding-bottom: 0;
    }
    .right-side {
      padding-top: 0;
      width: 100%;
    }
  }
  .btn-row {
    flex-direction: column-reverse;
    margin-bottom: 32px;
    padding: 0 44px;
    .v-btn {
      width: 160px;
      margin-bottom: 16px;
      width: 100%;
    }
  }
}
</style>
